import { useAuth0 } from "@auth0/auth0-react";
import { createClient } from "graphql-ws";
import { useMemo } from "react";
import { useParams } from "react-router-dom";

import type { BrandMatch } from "~/routes/root";

const minTimeout = 30000 + Math.floor(Math.random() * 30000);
const maxTimeout = 5 * 60000;

export const useGraphQLSubscription = () => {
  const { getAccessTokenSilently } = useAuth0();
  const { brandId } = useParams<BrandMatch>();

  const client = useMemo(
    () =>
      createClient({
        url: import.meta.env.REACT_APP_WS_URL_NEW as string,
        lazy: true,
        shouldRetry: () => true,
        connectionAckWaitTimeout: minTimeout,
        keepAlive: maxTimeout,
        connectionParams: async () => {
          return {
            Authorization: await getAccessTokenSilently(),
            sellerId: brandId,
          };
        },
        on: {
          error: () => {
            getAccessTokenSilently({ cacheMode: "off" });
          },
        },
      }),
    [brandId, getAccessTokenSilently],
  );

  return client;
};
